













import { Component, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import getUrlParam from '@/common/utils/getUrlParam';
import PosterMask from '@/components/common/index/PosterMask.vue';
import getActivityType from '@/common/utils/getActivityType';

@Component({
  components: {
    'poster-mask': PosterMask
  }
})
export default class ShareIcon extends Vue {
  @Getter('showWantDo') showWantDo!: boolean;
  @Getter('nickname') nickname!: string;
  @Getter('uid') uid!: string;
  @Getter('avatar') avatar!: string;
  @Getter('urlUid') urlUid!: string;
  @Getter('posterName') posterName!: string;
  @Getter('startTime') startTime: any;
  @Getter('deadline') deadline!: number;
  @Getter('shareIcon') shareIcon!: string;

  showPosterMask: boolean = false;
  pageType: string = getUrlParam('type') as any;
  templateType: string = getActivityType();
  statusInterval: any = {};
  activityStatus: string = '';
  mounted() {
    this.statusInterval = setInterval(() => {
      this.getActivityStatus();
    }, 50);
  }
  getActivityStatus() {
    const activityDeadline: number = this.deadline;
    const activityStartTime: number = this.startTime;
    const nowTimestamp: number = new Date().valueOf();
    if (activityStartTime > nowTimestamp) {
      this.activityStatus = 'noStart';
    } else {
      if (nowTimestamp < activityDeadline) {
        this.activityStatus = 'startIng';
      } else {
        this.activityStatus = 'endIng';
      }
    }
  }
  hanldeToggleShare() {
    if (this.pageType !== 'share') return;
    const broadcastId = getUrlParam('broadcastId');
    if (this.templateType === 'distributeType') {
      // 分销
      if (this.activityStatus === 'noStart') {
        Vue.$toast.info('活动未开始');
      } else {
        console.log('nickname', this.nickname);
        if (this.nickname) {
          this.toMiniprogram();
        } else {
          Vue.$loading.show('正在加载..');
          setTimeout(() => {
            this.toMiniprogram();
            Vue.$loading.hide();
          }, 3000);
        }
      }
    } else if (this.templateType === 'distributeGroupType') {
      this.toInvite();
    } else {
      window.wx.miniProgram.navigateTo({
        url: `/pages/user-share/index?broadcastId=${broadcastId}&parentUid=${this.urlUid}&name=${this.posterName}&guide=true`
      });
    }
  }
  toMiniprogram() {
    const broadcastId = getUrlParam('broadcastId');
    const distributorId = getUrlParam('distributorId');
    const scene =
      `activityId=${broadcastId}&nickname=${this.nickname}&avatar=${this.avatar}` +
      (distributorId ? `&distributorId=${distributorId}` : `&distributorId=-1`) +
      (this.uid ? `&parentUid=${this.uid}` : `&parentUid=`);
    if (window.__wxjs_environment === 'miniprogram') {
      window.wx.miniProgram.navigateTo({
        url: `/pages/poster/index?${scene}&guide=true`
      });
    }
  }
  toInvite() {
    if (new Date().valueOf() < this.startTime) {
      Vue.$toast.error('活动未开始');
    } else {
      if (this.nickname) {
        const broadcastId = getUrlParam('broadcastId');
        const distributorId = getUrlParam('distributorId');
        const scene = `activityId=${broadcastId}&templateType=${this.templateType}&nickname=${this.nickname}&avatar=${this.avatar}&distributorId=${distributorId ? `${distributorId}` : `-1`}&parentUid=${this.urlUid}`;
        if (window.__wxjs_environment === 'miniprogram') {
          window.wx.miniProgram.navigateTo({
            url: `/pages/poster/index?${scene}`
          });
        }
      }
    }
  }
}
